const { __ } = wp.i18n;
const { registerBlockType } = wp.blocks;

const { InspectorControls } = wp.blockEditor;

const {
	PanelBody,
	SelectControl,
	Disabled
} = wp.components;
const { serverSideRender: ServerSideRender } = wp;

import icons from "../../../icons.js";
/**
 * Every block starts by registering a new block type definition.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-registration/
 */
registerBlockType("wp-apidae/descriptif", {
	title: __("Descriptifs", "wp-apidae"), // Block title.
	description: __("Affiche la description longue ou courte.", "wp-apidae"),
	icon: {
		foreground: '#EFB114',
		background: '#331F5B',
		src: icons.text
	},
	supports: {
    align: ['full','wide'],
  },
	example: {
  },
	attributes: {
		type: {
			type: "string",
			default: "descriptifCourt",
		},
		align: {
			type: 'string',
			default: '',
		},
	},
	edit: class extends wp.element.Component {
		render() {
			const props = this.props;
			const attributes = props.attributes;

			var template = window.WpApidaeTemplateData.settings;

			var fieldsOptions = [
				{label: 'Descriptif court', value:'descriptifCourt'},
				{label: 'Descriptif détaillé', value:'descriptifDetaille'},
			];

			return [
					<InspectorControls key={"inspector"}>
						<PanelBody title={__("Affichage")}>
						<SelectControl
							label={ __( 'Choisir un descriptif' ) }
							value={ attributes.type }
							options={fieldsOptions}
							onChange={ newValue => {
								props.setAttributes({
									type: newValue,
								});
							}}
						/>
						</PanelBody>
					</InspectorControls>
				,
						<Disabled>
						<ServerSideRender
							block="wp-apidae/descriptif"
							attributes={attributes}
							urlQueryArgs={{
							settings:template
						}}/>
					</Disabled>
				,
			];
		}
	},

	save: () => {
		return null;
	},
});
